import React, { Component } from 'react'

import K from '../../services/k'
import Axios from 'axios'
export class VerifyRiderAccountComponent extends Component {
  state = {
    isLoading: false,
    msg: '',
    email: '',
    pwd: '',
    hasError: false,
    token: '',
  }

  handleChange = (event) => {
    event.preventDefault()
    this.setState({ [event.target.name]: event.target.value })
  }

  componentDidMount() {
    const query = window.location.search

    const token = query.split('=')

    if (token !== '') {
      this.setState({ token: token[1] })
    }
  }

  handleLogin = async (e) => {
    e.preventDefault()
    this.setState({ isLoading: true })

    let body = {
      email: this.state.email,
      password: this.state.pwd,
    }

    await Axios.post(K.riderLogin, body, { 'Content-type': 'application/json' })
      .then((response) => {
        if (
          response &&
          response.message &&
          response.message.indexOf('log in') > -1
        ) {
          this.props.logOut()
          return
        }
        this.setState({ hasError: false })
        let { data } = response.data
        localStorage.setItem('rider_id', data.id)
        localStorage.setItem('rider_email', data.email)
        localStorage.setItem('rider_email', data.email)
        localStorage.setItem('rider_pwd', body.password)
        localStorage.setItem('rider_api_token', data.api_token)

        this.setState({ isLoading: false })

        const rider_api_token = localStorage.getItem('rider_api_token')

        if (rider_api_token !== '') {
          window.location.href = '/riderregistration'
        }
      })
      .catch((error) => {
        if (error.response.status !== 200 || error.response.status !== 201) {
          let errorsArr
          let formErrors
          switch (error.response.status) {
            case 403:
              this.setState({ msg: `${error.response.data.message}` })
              this.setState({ hasError: true })
              this.setState({ isLoading: false })
              break
            case 404:
              this.setState({
                msg: 'Please try again later, by creating an account first',
              })
              this.setState({ hasError: true })
              this.setState({ isLoading: false })

              break
            case 500:
              this.setState({
                msg: 'internal server error pleace contact customer support',
              })
              this.setState({ hasError: true })
              this.setState({ isLoading: false })

              break
            case 422:
              errorsArr = error.response.data.errors
              formErrors = []

              Object.keys(errorsArr).map((error) => {
                formErrors.push(`${errorsArr[error][0]}\n`)
              })

              this.setState({ msg: `${formErrors}` })
              this.setState({ hasError: true })
              this.setState({ isLoading: false })

              break

            default:
              break
          }
        }
      })
  }

  render() {
    return (
      <>
        <div className="main-wrapper inner--page rider-page">
          <section
            className="hero-banner inner-banner form-page"
            style={{ backgroundImage: `url('images/rider-banner.png')` }}
          >
            <div className="container">
              <div className="row pt-100">
                <div className="col-lg-10 offset-lg-1 col-md-10 offset-md-1">
                  <div className="partner-form">
                    <div className="heading-text border-bottom">
                      <h3 className="text-success mb-5">
                        {this.state.token
                          ? 'Success Login To update Your profile'
                          : ''}
                      </h3>
                    </div>
                    {this.state.isLoading ? (
                      <span>
                        <p className="text-spinner-font text-center">
                          <i className="fa fa-spinner fa-spin spinner-font"></i>
                          &nbsp;Please Wait...
                        </p>
                      </span>
                    ) : (
                      <form>
                        <div className="row">
                          <div className="col-lg-6">
                            <label>Email</label>
                            <div className="form-group">
                              <input
                                type="text"
                                name="email"
                                placeholder="Email Address"
                                onChange={this.handleChange}
                                defaultValue={this.state.email}
                              />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label>Password</label>
                              <input
                                type="password"
                                name="pwd"
                                placeholder="Password"
                                onChange={this.handleChange}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            {this.state.hasError ? (
                              <div className="col-lg-6">
                                <p className="text-danger">{this.state.msg}</p>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>
                          <div className="col-lg-6">
                            {this.state.token ? (
                              <button
                                className="primary-btn"
                                onClick={this.handleLogin}
                              >
                                Login
                              </button>
                            ) : (
                              ''
                            )}
                          </div>
                        </div>
                      </form>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </>
    )
  }
}

export default VerifyRiderAccountComponent
